
// React Imports
import React, { isValidElement, useEffect, useState } from "react"

// Packge Imports
import { observer } from "mobx-react"
import { Col, Modal, Row, Toast } from "react-bootstrap"

// Project Imports
import { Button as UiButton } from "components"

// CSS Imports
import "../../components/add-member-card-modal.css"
import { CheckSecondaryImg, CloseIconBlack, FamilyIcon } from "constants/Images"
import EmployeesCardInModal from "./EmployeesCardInModal"
import { validationOtherFieldEmpoyees, checkIsMemberFieldSelected,  updateValue } from "modules/family-details-form/non-individual-journey-form/utils"
import FamilyMemberTypeEnum from "modules/family-details-form/FamilymemberTypeEnum"

const AddEmployeeCardModal = (props) => {
    const { show, onHide, formController, EmployeeList, updateValues } = props
    
    const [showDoneButton, setShowDoneButton] = useState(true);
    const [donechange, setDoneChanges] = useState(false)
    console.log("EmployeeList ", EmployeeList)
    let EmployeesDetails = []
    let memberArray = []
    useEffect(() => {
        let checkAllFields = checkIsMemberFieldSelected(formController, donechange)
        //  if (checkAllFields) {
        //        setShowAddButton(true)
        //        setShowDoneButton(false)
        //      }
        setShowDoneButton(false)
    }, [show])
    if (EmployeeList) {
        for (const [key, value] of Object.entries(EmployeeList)) {
            if (key.startsWith("employee")) {
                EmployeesDetails.push({
                    key: key,
                    value: value
                })

            }
            if (key.startsWith("family_member")) {
                EmployeesDetails.push({
                    key: key,
                    value: value
                })

            }

        }
    }

    if (EmployeeList) {


        for (const item of Object.entries(EmployeeList)) {
            // if any validation in members fields
            let memberName = item[0]
            if (item[1].hasError && !memberArray.includes(memberName.replaceAll('_', " "))) {
                memberArray.push(memberName.replaceAll('_', " "))
            }

        }
    }
    const handleDoneButton = (childState) => {
        setShowDoneButton(childState)
        // setShowAddButton(!childState)
    };

    const handleDoneClick = (formController) => {

        setDoneChanges(true)
        setShowDoneButton(false);
        let isvalid = validationOtherFieldEmpoyees(formController)
        if (isvalid) {
            if (checkIsMemberFieldSelected(formController, true)) {
                setShowDoneButton(false);
                props.onAddMember(onHide)
                // setShowAddButton(true);
                // setShowDonePopUp(true)
            } else {
                setShowDoneButton(true);
                // setShowAddButton(false);
            }
        }
    };
    return (
        <div className="add-member-card-modal">
            <Modal
                className="date-picker-modal left-bottom-swipe-modal"
                show={show}
                onHide={onHide}
                keyboard={false}
                backdrop="static"
            >
                <Modal.Header
                    closeButton={false}
                    className="pb-0 mx-md-2 border-bottom-0"
                >
                    <Modal.Title className="text-primary-title-label-color">
                        <img
                            src={FamilyIcon}
                            alt="family-icon"
                            className="add-family-member-card-modal-top-img"
                        />
                        <span style={{ color: "#DF6336", fontSize: "18px" }}>{String(EmployeesDetails[0]?.key).startsWith("employee") ? 'Employee Details' : 'Family Members'}</span>
                    </Modal.Title>

                    <div className="d-flex mt-2 pt-1">

                        <UiButton variant='' className='d-inline-flex align-items-center p-0' onClick={() => { handleDoneClick(formController) }}>

                            <img src={CheckSecondaryImg} alt='checked-icon' className='fm-modal-btn-icon font-weight-bold' />
                            <p className='mb-0 font-size-16 font-size-md-12 font-weight-bold text-secondary pl-1'>Add</p>
                        </UiButton>

                        <UiButton variant='' className='d-inline-flex align-items-center p-0 ml-2' onClick={() => onHide()}>
                            <img src={CloseIconBlack} alt='close-icon' className='fm-modal-btn-icon font-weight-bold' />
                            <p className='mb-0 font-size-16 font-size-md-12 font-weight-bold pl-1'>Cancel</p>
                        </UiButton>
                    </div>
                </Modal.Header>
                <Modal.Body className="px-1 overflow-auto py-2 add-family-member-card">

                    {formController?.$('members').hasError && <div className="px-2 text-danger "> Please scroll down to check error in  <span className="text-capitalize">{memberArray.join(", ")}</span> </div>}

                    {
                        EmployeesDetails?.map((item, index) => {
                            return (
                                <EmployeesCardInModal
                                    memberId={index}
                                    employeeName={item.key}
                                    data={item.value}
                                    updateValues={updateValue}
                                    formController={formController}
                                    onDoneButtonChange={handleDoneButton}
                                    isdone={showDoneButton}
                                    indexOfEployee={index}
                                    employeesDetails={EmployeesDetails}
                                    checkDoneChange={donechange}
                                />
                            )
                        })
                    }
                </Modal.Body>
            </Modal>
        </div >
    )
}

export default observer(AddEmployeeCardModal)